import React from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import ClientSideConfigSelector from '../../recoil/cashout/ClientSideConfigSelector';
import LifetimeBalanceSelector from '../../recoil/cashout/LifetimeBalanceSelector';
import AccessInfoSelector from '../../recoil/selectors/AccessInfoSelector';
import DiamondBalance from './common/DiamondBalance';
import InventorySelector from '../../recoil/cashout/InventorySelector';
import RewardsInfo from './RewardsInfo';
import ConvertLink from './ConvertLink';
import ItemConvertLink from './ItemConvertLink';
import CashoutLink from './CashoutLink';

export default function Rewards() {
  const { t } = useTranslation(null, { useSuspense: false });
  const config = useRecoilValue(ClientSideConfigSelector);
  const { networkUserId } = useRecoilValue(AccessInfoSelector);
  const {
    live: {
      claimReward: {
        categories: {
          conversion: conversionCurrency,
        },
        contentFilters: {
          requireInventoryKeys = [],
          minConversionLifetimeBalance = 0,
        },
        itemConvert: {
          enabled: itemConvertEnabled = false,
        } = {},
      } = {},
    },
  } = config;

  const lifetimeBalance = useRecoilValue(LifetimeBalanceSelector(networkUserId));

  const inventory = useRecoilValue(InventorySelector);

  const isConversionEnabled = () => {
    if (!conversionCurrency) {
      return false;
    }

    return lifetimeBalance >= minConversionLifetimeBalance;
  };

  const isItemConvertEnabled = () => itemConvertEnabled === true;

  const isRewardsEnabled = () => {
    if (!requireInventoryKeys) {
      return true;
    }

    const inventoryKeys = (inventory || []).map((x) => x.productSku);
    return requireInventoryKeys.every((key) => inventoryKeys.includes(key));
  };

  if (!isRewardsEnabled()) {
    return <RewardsInfo />;
  }

  return (
    <>
      <DiamondBalance />

      <div className="member-diamonds-conversion">
        <ul>
          {isItemConvertEnabled() && (
          <li>
            <ItemConvertLink />
          </li>
          )}
          {isConversionEnabled() && (
          <li>
            <ConvertLink />
          </li>
          )}
          <li>
            <CashoutLink />
          </li>
        </ul>
        <h4>{t('index_what_are_diamonds_')}</h4>
        <p>{t('index_what_are_diamonds_description')}</p>
      </div>
    </>
  );
}
